import {ActionTree} from "vuex";
import axios, {AxiosResponse} from 'axios';
import {ReportFilter, ReportsState} from "@/store/settings/reports/types";
import {RootState} from "@/store/types";
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<ReportsState, RootState> = {
  getReports: async ({commit, dispatch}, data: ReportFilter) => {
    commit('setLoading', true);
    try {
      const resp: AxiosResponse = await axios({url: '/stats-api/reports', params: data});
      commit('setReports', resp.data.reports);
      return resp;
    } catch (err) {
      throw err
    } finally {
      commit('setLoading', false)
    }
  },
  downloadReport: ({commit, dispatch}, id: number) => {
    return directDownload(`/stats-api/reports/${id}/download` )
  },
  deleteReport: async ({commit, dispatch}, data: { report_id: number, filter: ReportFilter }) => {
    commit('setLoading', true);
    try {
      const resp = await axios.delete(`/stats-api/reports/${data.report_id}`);
      await dispatch('getReports', data.filter);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  }
}
